import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03f174d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "schedule-event-box__time-start" }
const _hoisted_2 = { class: "schedule-event-box__time-duration" }
const _hoisted_3 = { class: "schedule-event-box__abstract" }
const _hoisted_4 = { class: "schedule-event-box__title-row" }
const _hoisted_5 = { class: "schedule-event-box__title" }
const _hoisted_6 = { class: "schedule-event-box__abstract-text" }
const _hoisted_7 = { class: "schedule-event-box__footer" }
const _hoisted_8 = { class: "schedule-event-box__track" }
const _hoisted_9 = { class: "schedule-event-box__room" }

import { toRefs, computed, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ScheduleEventBox',
  props: {
    event: {},
    rowspan: {}
  },
  setup(__props: any) {

const props = __props;

const hoursToMinutes = (time: string) => {
  const hours = parseInt(time.substr(0, 2));
  const minutes = parseInt(time.substr(3, 2));
  return hours * 60 + minutes;
};

const getEventBoxStyle = () => {
  const calcMinHeight = props.rowspan && props.rowspan * 75 || 0;
  return {minHeight: `${calcMinHeight}px`}
}

const getEventTrackColor = (eventType: string) => {
  switch (eventType) {
    case "Hands-on":
      return {
        backgroundColor: "rgb(1, 255, 229)",
        color: "black",
      };
    case "Societal challenges":
      return {
        backgroundColor: "#81ff70",
        color: "black",
      };
    case "Ethereum stack":
      return {
        backgroundColor: "#5400ff",
        color: "white",
      };
    case "Community":
      return {
        backgroundColor: "#ffff01",
        color: "black",
      };
    case "Miscellaneous":
      return {
        backgroundColor: "black",
        color: "white",
      };
    default:
      return {
        backgroundColor: "rgb(255, 255, 255)",
        color: "black",
      };
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "schedule-event-box",
    style: _normalizeStyle(getEventBoxStyle())
  }, [
    _createElementVNode("div", {
      class: "schedule-event-box__time",
      style: _normalizeStyle(getEventTrackColor(_ctx.event.track))
    }, [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.event.start), 1),
      _createElementVNode("div", _hoisted_2, _toDisplayString(hoursToMinutes(_ctx.event.duration)) + " min ", 1)
    ], 4),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.event.title), 1)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.event.persons, (person, index) => {
          return (_openBlock(), _createElementBlock("span", {
            class: "schedule-event-box__persons-name",
            key: person.public_name
          }, _toDisplayString(_ctx.event.persons.length === index + 1
              ? person.public_name
              : person.public_name + ", "), 1))
        }), 128)),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.event.abstract), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.event.track), 1),
        _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.event.room), 1)
      ])
    ])
  ], 4))
}
}

})